<template>
  <div>
    <div class="modal-backdrop"></div>

    <div class="modal task">
      <div class="content">
        <div class="page-builder-close-btn">
          <div class="btn-close" v-if="!loading" @click="close()"></div>
        </div>

        <div class="custom-page-wrapper" v-if="!loading">
          <div class="report-tools">
            <div
              class="round-button item"
              @click="exportPDF()"
              v-b-tooltip.hover.top
              title="PDF Herunterladen"
            >
              <i class="fas fa-file-pdf"></i>
            </div>
            <div
              class="round-button item"
              @click="exportHTML()"
              v-b-tooltip.hover.top
              title="HTML Herunterladen"
            >
              <i class="fas fa-file-invoice"></i>
            </div>
          </div>
          <div class="custom-page-header">
            <b-form-input
              v-model="task.props.reportName"
              placeholder="Dateinamen"
              :class="{ 'is-duplicate': isNameDuplicate, error: shakeName }"
            ></b-form-input>
          </div>
        </div>
        <div v-if="!loading" class="page-builder-outer-wrapper">
          <PageBuilderComponent
            ref="pageBuilderComponentRef"
            :task="task"
            :taskProps="task.props"
            :userTheme="process && process ? process.style : null"
            @onContentChange="onContentChange"
          ></PageBuilderComponent>
        </div>
        <LoadingSpinner loadingCaption="Wird gespeichert..." v-show="loading" />
      </div>
    </div>
  </div>
</template>

<script>
import { PageBuilderComponent } from '@codelos.io/page-builder';
import '@codelos.io/page-builder/dist/page-builder.css';
import LoadingSpinner from '../widgets/LoadingSpinner.vue';
import { generatePdf } from '../../services/workflow.service';

export default {
  name: 'pageBuilderWarp',

  props: {
    task: Object,
    process: { type: Object, required: true },
    getFileNamesFromProps: {
      type: Function,
      required: true,
      default: () => {},
    },
  },

  created() {
    // for backward comparability of report name
    if (!this.task.props.reportName) {
      this.task.props.reportName = `file-${new Date().getTime().toString()}`;
    }
    // for backward comparability of bold rows
    if (this.task.props.jsonContent) {
      this.task.props.jsonContent.children.forEach((pageNode) => {
        if (pageNode.type === 'table' && !('boldRows' in pageNode.value)) {
          pageNode.value['boldRows'] = new Array(pageNode.value.rows).fill(
            false
          );
        }
      });
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.task.props.jsonContent =
        this.task.props.jsonContent ||
        this.$refs.pageBuilderComponentRef.pageBuilderNodes;
      this.task.props.htmlContent =
        this.task.props.htmlContent ||
        this.$refs.pageBuilderComponentRef.getSanitizedString();
    });
  },
  data() {
    return {
      outputContent: null,
      loading: false,
      shakeName: false,
    };
  },
  computed: {
    isNameDuplicate() {
      const reportFilenames = this.getFileNamesFromProps(
        'PageBuilder',
        'reportName',
        this.task.id
      );
      return reportFilenames.includes(this.task.props.reportName);
    },
  },
  methods: {
    async close() {
      if (!this.isNameDuplicate) {
        this.loading = true;
        await this.saveAsOutput();
        setTimeout(() => {
          this.loading = false;
          this.$emit('close');
        }, 1000);
      } else {
        this.shakeName = true;
        setTimeout(() => {
          this.shakeName = false;
        }, 500);
      }
    },

    onContentChange(event) {
      this.task.props.jsonContent = event.jsonContent;
      this.task.props.htmlContent = event.htmlContent;
    },

    async saveAsOutput() {
      const output = await this.getReport();
      this.task.output = [output];
      this.$set(this.task, 'output', this.task.output.concat(this.task.input));
    },

    async getReport() {
      const taskInput = this.task.input.filter((taskInput) =>
        [
          'text',
          'number',
          'email',
          'radio',
          'timeseries',
          'formatted_number',
        ].includes(taskInput.type)
      );
      const payload = {
        content: this.task.props.htmlContent,
        values: taskInput,
        filename: this.task.props.reportName,
      };

      try {
        const res = await generatePdf(payload);

        if (res.status != 200) throw new Error(res.statusText);

        return {
          label: `${payload.filename}.pdf`,
          name: `${payload.filename}.pdf`,
          type: 'file',
          value: res.data.data,
        };
      } catch (err) {
        return {
          label: 'error',
          type: 'text',
          value: err,
        };
      }
    },

    async exportPDF() {
      this.loadingMessage = 'PDF-Dokument wird erstellt...';
      this.loading = true;
      const report = await this.getReport();
      const linkSource = `data:application/pdf;base64,${report.value}`;
      const name = this.replacePlaceholder(this.task.props.reportName);
      const link = document.createElement('a');
      link.href = linkSource;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.loading = false;
    },

    replacePlaceholder(name) {
      if (name.includes('{')) {
        let placeholder = name.split('{')[1].split('}')[0];
        let match = this.task.input.filter((e) => e.name == placeholder)[0]
          .value;
        name = name.replace('{' + placeholder + '}', match);
      }
      return name;
    },
    exportHTML() {
      this.loadingMessage = 'HTML-Dokument wird erstellt...';
      this.loading = true;
      const name = this.replacePlaceholder(this.task.props.reportName);
      this.copyToClipboard(this.task.props.htmlContent);
      this.loading = false;
    },

    copyToClipboard(text) {
      const dummy = document.createElement('textarea');
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
    },
  },

  components: {
    PageBuilderComponent,
    LoadingSpinner,
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  max-width: 1147px;
  background: #ffffff;
  border-radius: 4px;
  display: block;
  width: 80%;
  height: 98%;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  top: 0;
  position: absolute;
  left: 10%;
  top: 1%;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  padding-top: 35px;
  height: 100%;
}

.pull-right {
  float: right;
  margin-right: 5px;
  margin-top: 5px;
}
::v-deep .column-selector,
::v-deep .row-selector {
  box-shadow: unset;
  padding: 0;
}

::v-deep input {
  box-sizing: border-box;
}
::v-deep .codelos-page-content {
  text-align: left;
  font-size: 16px;
  color: #212529;
}

.codelos-page-content * {
  box-sizing: border-box !important;
}

::v-deep .codelos-hr-block .element-wrapper .draggible-icon svg {
  top: 1px;
}
::v-deep .codelos-text-block .element-wrapper .draggible-icon svg {
  top: 11px;
}
::v-deep .element-block {
  line-height: 1.5;
}

::v-deep .modal-backdrop.custom-backdrop {
  background: transparent;
}
::v-deep .codelos-dropdown-child,
::v-deep .codelos-dropdown {
  box-sizing: border-box;
}
::v-deep .codelos-dropdown-item {
  line-height: 1.5;
}

::v-deep .codelos-table-block .table-wrap tr td input {
  font-size: 16px;
  color: #212529;
}
::v-deep .codelos-table-block .codelos-table-header td input {
  font-weight: 600;
  font-size: 18px;
  color: #212529;
}
::v-deep .codelos-table-block .table-centered .table-wrap table {
  box-sizing: border-box;
}
::v-deep .codelos-text-block .element-wrapper .draggible-icon {
  top: -9px;
}
.btn-close {
  position: relative;
  z-index: 9;
  top: 0;
  right: 0;
}

.loading.transparent {
  background-color: #9191912e;
}
.progress-icon-wrapper {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  text-align: center;
}

.progress-icon-wrapper .progress-icon {
  left: unset;
  margin: 0 auto;
  top: unset;
  margin-top: 30px;
}
.progress-icon-wrapper .progress-icon:after {
  border-color: #313745 transparent #313745 transparent;
}
.custom-page-wrapper {
  max-width: 100%;
  margin: 0 auto 0;
  padding: 0;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  padding: 0 31px;
}
.custom-page-header {
  width: 100%;
}
.custom-page-header input {
  border: none;
  height: 100%;
  color: #464d5d;
  margin: 0;
  font-size: 21px;
  font-weight: 500;
  padding: 12px 0;
  cursor: text;
  height: 51px;
}

.custom-page-header input:focus {
  outline: none;
  box-shadow: none;
}

.custom-page-header input::placeholder {
  color: #8b8b8b;
}
.report-tools {
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-top: 0px;
  justify-content: flex-end;
}

.report-tools .round-button {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0.5px 0.87px 5px 0 rgba(0, 0, 0, 0.28);
  border-radius: 100%;
  font-size: 17px;
  color: #2c3e50;
  margin-left: 20px;
  cursor: pointer;
}

.is-duplicate {
  background: #ff050578;
}

.error {
  animation: shake 0.2s ease-in-out 0s 2;
  border: none;
  box-shadow: 0 0 0.5em red;
}

@keyframes shake {
  0% {
    margin-left: 2rem;
  }
  25% {
    margin-left: 2.2rem;
  }
  75% {
    margin-left: 1.8rem;
  }
  100% {
    margin-left: 2rem;
  }
}
.modal.task .page-builder-close-btn {
  position: absolute;
  right: 10px;
  top: 10px;
}

.modal.task .page-builder-close-btn .btn-close {
  margin-left: auto;
}
.modal.task .page-builder-outer-wrapper {
  height: calc(100% - 95px);
  overflow: auto;
}
</style>
